<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    },
    styleList: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showTitle: false
    }
  },
  computed: {
    // 加前缀
    prefixImgUrl () {
      return this.imgUrl ? this.$imgParse(this.imgUrl) : this.imgUrl
    }
  },
  watch: {
    imgUrl: {
      handler () {
        this.showTitle = !this.imgUrl
      },
      immediate: true
    }
  },
  methods: {
    errorImg () {
      console.log('报错了呀：', this.imgUrl)
      this.showTitle = true
    }
  }
}
</script>

<template>
  <div
    class="the-avatar"
    :style="styleList"
  >
    <div
      v-if="showTitle"
      class="title"
    >
      {{ title.trim().slice(0,1) }}
    </div>
    <img
      v-else
      class="avatar"
      :src="prefixImgUrl"
      @error="errorImg"
    />
  </div>
</template>

<style lang='scss' scoped>
.the-avatar {
  width: 46px;
  height: 46px;
  border: 1px solid #f4f4f4;
  overflow: hidden;
  font-size: 16px;
  border-radius: 6px;
}
.avatar {
  width: 100%;
  height: 100%;
}
.title {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: linear-gradient(to right top, #7bb0ff 0%, #5197ff 100%);
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/BaseAvatar.vue